/* eslint-disable react/prop-types */
import React, { Fragment } from 'react';
import { ContactCard, SocialMediaLink } from 'C4';

const ContactGroup = ({ category, link, contacts }) => {
  return (
    <Fragment>
      {contacts.length > 0 && <div className="contactsHeader">
        <h1>{category}</h1>

        {link && (
          <div>
            {' '}
            {Object.keys(link).map((key) => (
              <SocialMediaLink icon={key} link={link[key]} />
            ))}{' '}
          </div>
        )}
      </div>}
      {contacts.map((contact) => (
        <div className="contactView">
          <ContactCard
            name={contact.name}
            description={contact.other_copy}
            title={contact.title}
            email={contact.emails[0].email}
          />
        </div>
      ))}
    </Fragment>
  );
};

export default ContactGroup;
